import { Config } from '../../config'

export const weberConfig: Config = {
  partner: 'weber',
  catalog: 'partner',
  displayName: 'Weber',
  accentColor: '#5392c3',
  host: 'seating.weberscientific.com',
  extraAttributes: {
    hideProductPageButton: true,
  },
}

